// packages/eden-icons-raw/src/utils/toHTMLString.js
var attributeReplacements = {
  clipRule: "clip-rule",
  fillRule: "fill-rule"
};
var getAttributeName = (prop) => attributeReplacements[prop] || prop;
var propsToString = (props) => Object.keys(props).reduce(
  (accumulator, currentProp) => accumulator += ` ${getAttributeName(currentProp)}="${props[currentProp]}"`,
  ""
);
var typeSpecificDefaultProps = {
  svg: {
    style: `width: 1em; height: 1em;`
  },
  path: {
    fill: "currentColor"
  }
};
var toHTMLString = ({ type, props, children }) => {
  const mergeAllTheThings = {
    ...typeSpecificDefaultProps[type],
    ...props
  };
  if (Array.isArray(children)) {
    return `<${type}${propsToString(mergeAllTheThings)}>${children.map((item) => toHTMLString(item)).join("")}</${type}>`;
  } else if (children) {
    return `<${type}${propsToString(mergeAllTheThings)}>${children}</${type}>`;
  } else {
    return `<${type}${propsToString(mergeAllTheThings)}></${type}>`;
  }
};
var toHTMLString_default = toHTMLString;
export {
  toHTMLString_default as default
};
